export const InitialValueBanco = Object.freeze({
    IdBanco: 0,
    Nombre: "",
    TasaCobro: 0,
})